/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateInstrumentLinkStatusesRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/UpdateInstrumentLinkStatuses.pb'
import {UpdateInstrumentLinkStatusesResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/UpdateInstrumentLinkStatuses.pb'


export const updateInstrumentLinkStatuses = (request:UpdateInstrumentLinkStatusesRequest, options?: CashRequestOptions) => post<UpdateInstrumentLinkStatusesRequest, UpdateInstrumentLinkStatusesResponse>("/2.0/cash/update-instrument-link-statuses", request, {...options, rejectOnError: true })